import { Inline, Stack, xcss, Box } from '@atlaskit/primitives';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import React from 'react';

const DEFAULT_TOOLBAR_SKELETON_HEIGHT = '16px';
const SECOND_TOOLBAR_SKELETON_WIDTH = '78px';

const toolbarContainerStyles = xcss({
  marginBottom: 'space.300'
});

const toolbarStyles = xcss({
  gap: 'space.100',
  paddingTop: 'space.250',
  paddingBottom: 'space.250',
  paddingLeft: 'space.500',
  paddingRight: 'space.500'
});

export const DatabaseToolbarSkeleton = () => {
  return (
    <Stack xcss={toolbarContainerStyles} testId="database-toolbar-skeleton">
      <Box style={{ borderBottom: `1px solid ${token('color.border')}` }}>
        <Inline xcss={toolbarStyles}>
          <Skeleton height={DEFAULT_TOOLBAR_SKELETON_HEIGHT} width="16px" isShimmering />
          <Skeleton height={DEFAULT_TOOLBAR_SKELETON_HEIGHT} width="180px" isShimmering />
        </Inline>
      </Box>
      <Box style={{ borderBottom: `1px solid ${token('color.border')}` }}>
        <Inline xcss={[toolbarStyles]}>
          <Skeleton
            height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
            width={SECOND_TOOLBAR_SKELETON_WIDTH}
            isShimmering
          />
          <Skeleton
            height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
            width={SECOND_TOOLBAR_SKELETON_WIDTH}
            isShimmering
          />
          <Skeleton
            height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
            width={SECOND_TOOLBAR_SKELETON_WIDTH}
            isShimmering
          />
          <Skeleton
            height={DEFAULT_TOOLBAR_SKELETON_HEIGHT}
            width={SECOND_TOOLBAR_SKELETON_WIDTH}
            isShimmering
          />
        </Inline>
      </Box>
    </Stack>
  );
};
